/** Convert numeric inch measurements and ranges; leave other content unchanged. */
function convertMeasurement(value) {
  const match = value.match(/^(\s*)(\d+(?:\.\d+)?)(?:\s*([-–])\s*(\d+(?:\.\d+)?))?(\s*)(?:inches|inch|in|["″])?\s*$/i);
  if (!match) return null;
  const centimeters = (number) => String(Math.round(Number(number) * 2.54 * 10) / 10);
  const range = match[4] ? `${match[3]}${centimeters(match[4])}` : '';
  return `${match[1]}${centimeters(match[2])}${range}${match[5]}`;
}

class SizeGuide extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    this.querySelector('.size-guide__trigger')?.addEventListener('click', () => dialog.showModal(), { signal });
    this.querySelector('.size-guide__close')?.addEventListener('click', () => dialog.close(), { signal });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    }, { signal });

    this.measurements = [];
    this.querySelectorAll('.size-guide__chart td, .size-guide__chart th[data-measurement]').forEach((cell) => {
      if (cell.hasAttribute('data-no-convert') || (cell.cellIndex === 0 && !cell.hasAttribute('data-measurement'))) return;
      const walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const original = node.textContent;
        const converted = convertMeasurement(original);
        if (converted !== null) this.measurements.push({ node, original, converted });
      }
    });
    this.querySelectorAll('[data-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        const cm = button.dataset.unit === 'cm';
        this.measurements.forEach(({ node, original, converted }) => {
          node.textContent = cm ? converted : original;
        });
        this.querySelectorAll('[data-unit]').forEach((unitButton) => {
          unitButton.setAttribute('aria-pressed', String(unitButton === button));
        });
      }, { signal });
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.measurements?.forEach(({ node, original }) => { node.textContent = original; });
    this.querySelectorAll('[data-unit]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.unit === 'in'));
    });
  }
}

if (!customElements.get('size-guide')) customElements.define('size-guide', SizeGuide);
